import ViewResellerModal from './ViewResellerModalContainer'

export default ViewResellerModal